import axios from "axios";
import {sleep} from "../helper/helper";

const newRequest = axios.create({
    baseURL: process.env.REACT_APP_URL,
    withCredentials: true,
});

newRequest.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

newRequest.interceptors.response.use(
    (response) => {
        return response; // kalau sukses, lanjut saja
    },
    (error) => {
        // Jika server mengembalikan status 401 (token invalid / expired)
        if (error.response && error.response.status === 401) {
            // Hapus token dan user kalau disimpan di localStorage
            localStorage.removeItem("token");
            localStorage.removeItem("user");

            // Redirect ke login
            sleep(500)
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);
export default newRequest;